const getters={
    num:state=>state.app.num,
}
export default getters